import styled from '@emotion/styled';

export const StyledMemberShip = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: 'fit-content',
});

export const StyledSelectedStore = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spaces[3],
    border: `1px solid ${theme.colors.light30}`,
    padding: `${theme.spaces[4]} ${theme.spaces[3]}`,
    marginBottom: theme.spaces[5],
}));

export const StyledStoreName = styled.div({
    display: 'flex',
    flexDirection: 'column',
});
